import Navbar from "./navbar"
import { Outlet } from "react-router"
import Loading from "./loading"
import React from 'react'

const Layout = () => {
    const [loading, setLoading] = React.useState<boolean>(false)

    return (
        <div className="relative flex flex-col min-h-screen">
            {loading &&
                <Loading />
            }
            <Navbar />
            <div className="flex-1 flex flex-col">
                <Outlet context={[loading,setLoading]} />
            </div>
        </div>
    )
}

export default Layout